import {Component, Input, OnInit} from '@angular/core';
import {TextUtils} from "../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-ecommerce-view-sidebar',
    templateUrl: './ecommerce-view-sidebar.component.html',
    styleUrls: ['./ecommerce-view-sidebar.component.scss'],
    standalone: false
})
export class EcommerceViewSidebarComponent implements OnInit {
  @Input() refundedShippingAmount: number = 0;
  @Input() refundedShippingTaxAmount: number = 0;
  @Input() sidebar = {
    header: TextUtils.getText('text_paymentSummary'),
    items: [
      {
        label: TextUtils.getText('text_subtotal'),
        value: '$500'
      },
      {
        label: TextUtils.getText('text_subtotal'),
        value: '$500'
      },
      {
        label: TextUtils.getText('text_subtotal'),
        value: '$500'
      },
      {
        label: TextUtils.getText('text_subtotal'),
        value: '$500'
      }
    ],
    footer: {
      label: TextUtils.getText('text_total'),
      value: '$500'
    },
    refunded: {
      label: TextUtils.getText('text_refunded'),
      value: '$500'
    },
    orderTotal: {
      label: TextUtils.getText('text_orderTotal'),
      value: '$500'
    },
    paid: {
      label: TextUtils.getText('text_paid'),
      value: '$500'
    },
    hasRefunds: {
      label: TextUtils.getText('text_refunded'),
      value: false
    }
  };

  constructor(
  ) {
  }

    ngOnInit() {
    }

  protected readonly Math = Math;
  protected readonly parseInt = parseInt;
}
